import React from 'react'
import SelectBox from 'containers/LoanApplication/components/commons/SelectBox'

class YesOrNoForm extends React.Component {
  onChange = (value) => {
    this.props.onChange(value)
  }

  render() {
    const {
      label,
      checked,
    } = this.props;

    return(
      <div>
        <div className='form-group mb-0'>
          <label>{label}</label>
        </div>

        <div className='row no-gutters'>
          <div className='col-12 col-sm-4 mr-2'>
            <SelectBox
              checked={ checked == true }
              value={ true }
              text='Yes'
              onChange={ this.onChange }
            />
          </div>
          <div className='col-12 col-sm-4 mr-2'>
            <SelectBox
              checked={ checked == false }
              value={ false }
              text='No'
              onChange={ this.onChange }
            />
          </div>
        </div>
      </div>
    )
  }
}

export default YesOrNoForm;
